"use client";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { useDiscountUpdate } from "@/hooks/useDiscountUpdate";
import { useAppSelector } from "@/store/hooks";
import { DateType, PageType } from "@/types/coupon/discount";
import { useState } from "react";
import { DateTimePicker } from "../ui/dateTimePicker";
import FormFieldWrapper from "./formFieldWrapper";

const ActiveDatesSection = ({ currentPage }: { currentPage: PageType }) => {
  const handleUpdate = useDiscountUpdate();
  const { start_date, end_date } = useAppSelector(
    (state) => state.discount[currentPage],
  );
  const [showEndDate, setShowEndDate] = useState(!!end_date);

  const handleDateChange = (
    field: "start_date" | "end_date",
    date: DateType | null,
  ) => {
    if (
      field === "start_date" &&
      end_date &&
      date &&
      date > new Date(end_date)
    ) {
      handleUpdate(currentPage, { start_date: date, end_date: date });
    } else {
      handleUpdate(currentPage, { [field]: date });
    }
  };

  const handleShowEndDateChange = (checked: boolean) => {
    setShowEndDate(checked);
    if (!checked) {
      handleUpdate(currentPage, { end_date: undefined });
    }
  };

  return (
    <FormFieldWrapper title="Active Dates">
      <div className="flex flex-col space-y-4">
        <DateTimePicker
          date={start_date ? new Date(start_date) : null}
          onDateChange={(date) => handleDateChange("start_date", date)}
        />
        <div className="flex items-center space-x-2">
          <Checkbox
            id="set-end-date"
            checked={showEndDate}
            onCheckedChange={handleShowEndDateChange}
          />
          <Label htmlFor="set-end-date">Set end date</Label>
        </div>
        {showEndDate && (
          <div className="flex space-x-4">
            <DateTimePicker
              date={end_date ? new Date(end_date) : null}
              onDateChange={(date) => {
                if (!date) {
                  handleDateChange("end_date", null);
                  return;
                }
                if (start_date) {
                  const start = new Date(start_date);
                  // If same day, check time
                  if (
                    date.getFullYear() === start.getFullYear() &&
                    date.getMonth() === start.getMonth() &&
                    date.getDate() === start.getDate() &&
                    date.getTime() < start.getTime()
                  ) {
                    return;
                  }
                }
                handleDateChange("end_date", date);
              }}
              disabledDate={(date) => {
                if (!start_date) return false;
                const start = new Date(start_date);
                start.setHours(0, 0, 0, 0);
                return date < start;
              }}
              startDate={start_date ? new Date(start_date) : null}
              isEndPicker={true}
            />
          </div>
        )}
      </div>
    </FormFieldWrapper>
  );
};

export default ActiveDatesSection;
